module.exports = "/fonts/developer-logotype-d-e2791f6db8e3100446a7de1fc37cf472.svg";